import { Component } from '@angular/core';

@Component({
    template: `
        CASLink can be installed as an App on your device.
  `
})
export class AndroidMessageComponent {
}
